import { Block } from '@basehub/data/replicache/index'
import { AtLeast } from '@basehub/utils/tree/index'
import { idToSourceBlockId } from '@basehub/data/replicache/mutators/repo-space/block/mutators/copy-on-write'
import { RepoUndoOps } from './manager'
import { RepoStoreFocusType } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/repo-store'

export const getBlockFocusOp = ({
  block,
  preferredTabKey,
  forcePreferredTabKey,
  focusType,
  elementIdOverride,
}: {
  block: AtLeast<Block, 'id' | 'sourceBlockId'>
  preferredTabKey: string | undefined
  forcePreferredTabKey?: boolean
  focusType: RepoStoreFocusType
  elementIdOverride?: string
}) => {
  return {
    op: 'focus',
    args: {
      focus: {
        type: focusType,
        blockId: idToSourceBlockId(block),
        elementIdOverride,
      },
      preferredTabKey,
      forcePreferredTabKey,
    },
  } satisfies RepoUndoOps[number]
}
